<template>
  <div>
    <Chat :initial-campaign-application="campaignApplication" />
  </div>
</template>

<script>
import Chat from './ChatComponent.vue';

export default {
  components: { Chat },
  props: ['campaignApplication'],
};
</script>
